import { InfoOutlined } from '@mui/icons-material';
import { Box, Divider, Stack, Tooltip, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';

import { VenueDateProperties } from '@/domain/project-venue-dates/entities/project-venue-dates.entity';
import { selectProjectVenuesPresetsItems } from '@/domain/project-venue-presets/project-venue-presets.selectors.ts';
import { FSCard } from '@/ui/components/FSCard';
import { QuizPanelLayout } from '@/ui/components/quiz-panel/QuizPanelLayout';
import { PercentageCursorBar } from '@/ui/components/score-bars/PercentageCursorBar';
import { useAppSelector } from '@/ui/hook/store.ts';
import { translate } from '@/ui/i18n';
import { VenueDatePreset } from '@/ui/pages/app/project/venue/dates/components/VenueDatePreset.tsx';

import { VenueDatesContext } from './VenueDatesContext';

export function VenueDatesQuizPanel({
  onClickPresets,
}: {
  onClickPresets: () => void;
}) {
  const presets = useAppSelector(selectProjectVenuesPresetsItems);
  const { panelOpen, setPanelOpen } = useContext(VenueDatesContext);
  const [selectedPreset, setSelectedPreset] = useState<
    VenueDateProperties | undefined
  >(undefined);

  useEffect(() => {
    if (presets.length > 0) {
      const SELECTED_PRESET_INDEX = 0;
      const weirdPresetForDefaultData: VenueDateProperties = {
        presetId: presets[SELECTED_PRESET_INDEX].id,
        avgCapacity: presets[SELECTED_PRESET_INDEX].avgCapacity || 0,
      };
      setSelectedPreset(weirdPresetForDefaultData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, presets);

  return (
    <QuizPanelLayout
      panelOpen={panelOpen}
      setPanelOpen={setPanelOpen}
      disablePadding
    >
      <CarbonBudget />
      <VenueDatePreset
        readonly
        selectedDatePreset={selectedPreset}
        onChangePreset={setSelectedPreset}
        onClickPresets={onClickPresets}
      />
    </QuizPanelLayout>
  );
}

function CarbonBudget() {
  return (
    <Box padding={3}>
      <FSCard
        variant="elevation"
        sx={{ p: 2, height: 'fit-content', borderRadius: '8px' }}
      >
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography fontSize={20} fontWeight={'bold'}>
            {translate('VenueDates.QuizPanel.carbon-budget')}
          </Typography>
          <Tooltip
            title={translate('VenueDates.QuizPanel.carbon-budget-infos')}
          >
            <InfoOutlined />
          </Tooltip>
        </Stack>
        <Stack mt={3}>
          <PercentageCursorBar percentage={0} />
        </Stack>
        <Stack direction={'row'} mt={2}>
          <Stack sx={{ width: '100%' }}>
            <Typography>
              {translate('VenueDates.QuizPanel.consummed')}
            </Typography>
            <Stack direction={'row'}>
              <Typography fontWeight={'bold'} fontSize={24}>
                0
              </Typography>
              <Typography sx={{ pt: '10px', ml: 0.5 }} fontSize={14}>
                teCO2
              </Typography>
            </Stack>
          </Stack>
          <Divider orientation="vertical" sx={{ mx: 2, height: '60px' }} />
          <Stack sx={{ width: '100%' }}>
            <Typography>
              {translate('VenueDates.QuizPanel.fixed-limit')}
            </Typography>
            <Stack direction={'row'}>
              <Typography fontWeight={'bold'} fontSize={24}>
                0
              </Typography>
              <Typography sx={{ pt: '10px', ml: 0.5 }} fontSize={14}>
                teCO2
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </FSCard>
    </Box>
  );
}
